import { MarketCountryCode } from '@backmarket/http-api/src/api-models/MarketCountryCode'

export const MANDATORY_MARKETS: Partial<Record<MarketCountryCode, boolean>> = {
  [MarketCountryCode.FR]: true,
  [MarketCountryCode.DE]: true,
}

export const TERMS_LINKS_BY_MARKETS: Partial<
  Record<MarketCountryCode, string>
> = {
  [MarketCountryCode.FR]:
    'https://backmarket.my.site.com/ssc/s/article/Terms-and-Conditions',
}
